'use client'

import { useEffect, useState, type ReactNode } from 'react'

interface HeroScrollWrapperProps {
  children: ReactNode
  className?: string
}

export const HeroScrollWrapper = ({ children, className }: HeroScrollWrapperProps) => {
  const [opacity, setOpacity] = useState(1)

  useEffect(() => {
    const mobileViewPortHeight = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--mobileHeight', `${mobileViewPortHeight}px`)

    const handleScroll = () => {
      const scrollY = window.scrollY
      const maxScroll = window.innerHeight
      const newOpacity = 1 - (scrollY * 0.8) / maxScroll
      setOpacity(Math.max(0.2, Math.min(1, newOpacity)))
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div style={{ opacity }} className={`min-w-0 max-w-full ${className ?? ''}`}>
      {children}
    </div>
  )
}
